import React from 'react';
import { View, Text, StyleSheet, ScrollView, Dimensions } from 'react-native';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTheme } from '../contexts/ThemeContext';

const { width } = Dimensions.get('window');

const PrivacyPolicyScreen = () => {
    const { colors } = useTheme();
    const isMobile = width < 768;

    const styles = StyleSheet.create({
        container: { flex: 1, backgroundColor: colors.background },
        scrollView: { flex: 1 },
        hero: {
            backgroundColor: '#1a1a4e',
            paddingVertical: 60,
            paddingHorizontal: 20,
        },
        heroContent: {
            maxWidth: 800,
            alignSelf: 'center',
            alignItems: 'center',
        },
        heroTitle: {
            fontSize: isMobile ? 28 : 40,
            fontWeight: '800',
            color: '#c9a44e',
            textAlign: 'center',
            marginBottom: 12,
        },
        heroSubtitle: {
            fontSize: 15,
            color: 'rgba(255,255,255,0.7)',
            textAlign: 'center',
        },
        content: {
            paddingVertical: 60,
            paddingHorizontal: 20,
            backgroundColor: '#fff',
        },
        contentContainer: {
            maxWidth: 800,
            alignSelf: 'center',
            width: '100%',
        },
        lastUpdated: {
            fontSize: 14,
            color: '#6b7280',
            marginBottom: 30,
        },
        section: {
            marginBottom: 32,
        },
        sectionTitle: {
            fontSize: 20,
            fontWeight: '700',
            color: '#1a1a4e',
            marginBottom: 12,
        },
        paragraph: {
            fontSize: 15,
            color: '#374151',
            lineHeight: 26,
            marginBottom: 12,
        },
        bulletList: {
            marginLeft: 16,
            marginBottom: 12,
        },
        bulletItem: {
            fontSize: 15,
            color: '#374151',
            lineHeight: 26,
            marginBottom: 6,
        },
    });

    return (
        <View style={styles.container}>
            <Header />
            <ScrollView style={styles.scrollView}>
                <View style={styles.hero}>
                    <View style={styles.heroContent}>
                        <Text style={styles.heroTitle}>Privacy Policy</Text>
                        <Text style={styles.heroSubtitle}>How we collect, use, and protect your information</Text>
                    </View>
                </View>

                <View style={styles.content}>
                    <View style={styles.contentContainer}>
                        <Text style={styles.lastUpdated}>Last Updated: December 2024</Text>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>1. Introduction</Text>
                            <Text style={styles.paragraph}>
                                Welcome to Modern Munshiji. We respect your privacy and are committed to protecting your personal data. This privacy policy explains how we collect, use, disclose, and safeguard your information when you use our services.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>2. Information We Collect</Text>
                            <Text style={styles.paragraph}>We may collect the following types of information:</Text>
                            <View style={styles.bulletList}>
                                <Text style={styles.bulletItem}>• Personal identification information (name, email, phone number)</Text>
                                <Text style={styles.bulletItem}>• Business information (GST number, PAN, business type)</Text>
                                <Text style={styles.bulletItem}>• Financial documents for filing purposes</Text>
                                <Text style={styles.bulletItem}>• Usage data and preferences</Text>
                            </View>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>3. How We Use Your Information</Text>
                            <Text style={styles.paragraph}>We use collected information to:</Text>
                            <View style={styles.bulletList}>
                                <Text style={styles.bulletItem}>• Process GST and ITR filings on your behalf</Text>
                                <Text style={styles.bulletItem}>• Communicate with you about our services</Text>
                                <Text style={styles.bulletItem}>• Improve our website and services</Text>
                                <Text style={styles.bulletItem}>• Comply with legal obligations</Text>
                            </View>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>4. Data Security</Text>
                            <Text style={styles.paragraph}>
                                We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. Your data is encrypted and stored securely on protected servers.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>5. Data Sharing</Text>
                            <Text style={styles.paragraph}>
                                We do not sell, trade, or rent your personal information to third parties. We may share information with government authorities as required for tax filings and compliance purposes.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>6. Your Rights</Text>
                            <Text style={styles.paragraph}>You have the right to:</Text>
                            <View style={styles.bulletList}>
                                <Text style={styles.bulletItem}>• Access your personal data</Text>
                                <Text style={styles.bulletItem}>• Request correction of inaccurate data</Text>
                                <Text style={styles.bulletItem}>• Request deletion of your data</Text>
                                <Text style={styles.bulletItem}>• Withdraw consent for data processing</Text>
                            </View>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>7. Contact Us</Text>
                            <Text style={styles.paragraph}>
                                If you have questions about this Privacy Policy, please contact us at support@modernmunshiji.com
                            </Text>
                        </View>
                    </View>
                </View>

                <Footer />
            </ScrollView>
        </View>
    );
};

export default PrivacyPolicyScreen;
